import { pfrTextTerms } from '../terms';

const PERK_APPROVAL_REQUEST = {
  NO_DISAPPROVE_PERMISSION: `You do not have permission to ${pfrTextTerms.disapprove.singularLowerCase} this request.`,
  REQUEST_ALREADY_PROCESSED: 'This request has already been processed.',
  NO_APPROVE_PERMISSION: `You do not have permission to ${pfrTextTerms.approve.singularLowerCase} this request.`,
  NO_VIEW_PERMISSION:
    'You do not have permission to view the details of this request.',
  NOT_FOUND: 'Perk approval request not found.',
  UPDATED: 'Perk approval request updated successfully.',
  ALREADY_PROCESSED: 'Perk approval request already processed.',
  NO_APPROVAL_HISTORY: 'No approval history exists for this perk',
} as const;

export default PERK_APPROVAL_REQUEST;
